/*
 * OfferDetails Messages
 *
 * This contains all the text for the OfferDetails container.
 */
import { defineMessages } from 'react-intl';

export const scope = 'app.components.CustomizeOffer';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Offerta Noleggio a Lungo Termine',
  },
  description: {
    id: `${scope}.description`,
    defaultMessage: ' ',
  },
  duration: {
    id: `${scope}.duration`,
    defaultMessage: 'Scegli la durata del noleggio',
  },
  distance: {
    id: `${scope}.distance`,
    defaultMessage: 'Scegli i km/anno',
  },
  deposit: {
    id: `${scope}.deposit`,
    defaultMessage: 'Scegli l\'anticipo',
  },
  bundle: {
    id: `${scope}.bundle`,
    defaultMessage: 'Scegli il pacchetto',
  },
  services: {
    id: `${scope}.services`,
    defaultMessage: 'Scegli servizi aggiuntivi',
  },
  accessories: {
    id: `${scope}.accessories`,
    defaultMessage: 'Scegli optional',
  },
  colors: {
    id: `${scope}.colors`,
    defaultMessage: 'Colori',
  },
  optionalAccessories: {
    id: `${scope}.optionalAccessories`,
    defaultMessage: 'Optional',
  },
  optionalsAndColorsLabel: {
    id: `${scope}.optionalsAndColorsLabel`,
    defaultMessage: 'Scegli optional e colori',
  },
  optionalsAndColorsDescription: {
    id: `${scope}.optionalsAndColorsDescription`,
    defaultMessage: 'Scegli il colore e altri optional per personalizzare ancora di più la tua vettura',
  },
  optionalsAndColorsBtn: {
    id: `${scope}.optionalsAndColorsBtn`,
    defaultMessage: 'Scegli',
  },
  terms: {
    id: `${scope}.terms`,
    defaultMessage: 'Il prezzo del canone mensile è soggetto a variazioni. Offerta economica limitata valida fino ad esaurimento scorte.',
  },
  fixed: {
    id: `${scope}.fixed`,
    defaultMessage: 'Non modificabile',
  },
  info: {
    id: `${scope}.info`,
    defaultMessage: '*I prezzi indicati sono da sommare alla rata mensile del Noleggio a Lungo Termine. Esempio: considerando un optional il cui costo è di € 180, con una durata contrattuale di 36 mesi, il canone mensile aumenterà di € 5 al mese.',
  },
});
